import type { ExportTypeValue } from '../../../../constants';
import { buildExportTypeFilter } from './filterGroups';
import { and, eq, is_null, neq, not_in, or, type WhereCondition } from './filterHelpers';

export type ForbiddenCategory =
  | 'Area'
  | 'Age'
  | 'Buying Propensity: Brand'
  | 'Buying Propensity: Brand Category'
  | 'Buying Propensity: Purchase Channel'
  | 'Gender'
  | 'Congressional District'
  | 'DMA'
  | 'State'
  | 'Zip Code';

export const forbiddenCategories = new Set<ForbiddenCategory>([
  'Area',
  'Age',
  'Buying Propensity: Brand',
  'Buying Propensity: Brand Category',
  'Buying Propensity: Purchase Channel',
  'Gender',
  'Congressional District',
  'DMA',
  'State',
  'Zip Code',
]);

const excludedShoppingCategories = [
  'Buying Propensity: Brand',
  'Buying Propensity: Brand Category',
  'Buying Propensity: Purchase Channel',
] as const;

const temporaryAffinityFilter = (): WhereCondition => {
  return or(
    neq('segment_type', 'Shopping'),
    is_null('segment_type', true),
    not_in('segment_category', excludedShoppingCategories),
    is_null('segment_category', true)
  );
};

export const getAlwaysAppliedFilters = (exportType?: ExportTypeValue | null): WhereCondition[] => {
  return [
    eq('is_archived', false),
    eq('status', 'ready'),
    neq('category', 'lookalike'),
    getIsNavOnlyFilter(),
    getNotInForbiddenCategoriesFilter(),
    temporaryAffinityFilter(),
    buildExportTypeFilter(exportType),
  ];
};

export const getIsNavOnlyFilter = (): WhereCondition => {
  return or(neq('is_nav_only', true), is_null('is_nav_only', true));
};

export const getNotInForbiddenCategoriesFilter = (): WhereCondition => {
  // Exclude pseudo category unconditionally; allow other categories if not in forbidden list or segment_category is null.
  return and(
    or(not_in('segment_category', Array.from(forbiddenCategories)), is_null('segment_category', true)),
    neq('category', 'pseudo')
  );
};
